import { SvgIcon, SvgIconProps } from './SvgIcon';

export const AttachmentIcon = (props: SvgIconProps): JSX.Element => {
  const { viewBox, ...rest } = props;

  return (
    <SvgIcon {...rest} viewBox={viewBox ?? '0 0 20 20'}>
      <path
        d="M10 18.5C7.23636 18.5 5 16.409 5 13.825L5 4.9C5 3.0215 6.62727 1.5 8.63636 1.5C10.6455 1.5 12.2727 3.0215 12.2727 4.9L12.2727 12.125C12.2727 13.298 11.2545 14.25 10 14.25C8.74545 14.25 7.72727 13.298 7.72727 12.125L7.72727 6.65909C7.72727 6.15701 8.13429 5.75 8.63636 5.75V5.75C9.13844 5.75 9.54545 6.15701 9.54545 6.65909L9.54545 12.2015C9.54545 12.669 10.4545 12.669 10.4545 12.2015L10.4545 4.9C10.4545 3.965 9.63636 3.2 8.63636 3.2C7.63636 3.2 6.81818 3.965 6.81818 4.9L6.81818 13.825C6.81818 15.4655 8.24545 16.8 10 16.8C11.7545 16.8 13.1818 15.4655 13.1818 13.825L13.1818 6.65909C13.1818 6.15701 13.5888 5.75 14.0909 5.75V5.75C14.593 5.75 15 6.15701 15 6.65909L15 13.825C15 16.409 12.7636 18.5 10 18.5Z"
        fill="currentColor"
        fillOpacity="0.6"
      />
    </SvgIcon>
  );
};
